import { useState, useEffect } from "react";
import {
  MapContainer,
} from "react-leaflet";
import L from "leaflet";

import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import Spinner from "react-bootstrap/Spinner";
import Alert from "react-bootstrap/Alert";

import { useQuery } from "react-query";
import {InfluxDB, flux} from '@influxdata/influxdb-client-browser';

import MapGuts from "./MapGuts";

const {
  REACT_APP_INFLUXDB_V2_URL,
  REACT_APP_INFLUXDB_V2_ORG,
  REACT_APP_INFLUXDB_V2_TOKEN,
} = process.env;

const REACT_APP_INFLUXDB_V2_BUCKET = "DefConTracker";

const sampleLatLng = (s) => L.latLng(s.latitude, s.longitude);

const influxApi = new InfluxDB({url: REACT_APP_INFLUXDB_V2_URL, token: REACT_APP_INFLUXDB_V2_TOKEN}).getQueryApi(REACT_APP_INFLUXDB_V2_ORG);

const query = flux`
  from(bucket: "${REACT_APP_INFLUXDB_V2_BUCKET}")
    |> range(start: -1mo)
    |> filter(fn: (r) => r["_measurement"] == "location")
    |> drop(columns: ["id"])
`;

function LastMonth(props) {
  const today = new Date().toLocaleDateString("en-US");
  const [displaySamples, setDisplaySamples] = useState([]);
  const [bounds, setBounds] = useState();
  const view = 'heatmap';

  const { isLoading, error, data: samples = [] } = useQuery("current", async () => {
    const results = await influxApi.collectRows(query);
    const points = results.reduce((hsh, line) => {
      const { _field, _time, _value, who = '' } = line;
      const obj = hsh[_time] || {};
      if (_field === "lat") {
        obj.latitude = _value;
      } else if (_field === "lon") {
        obj.longitude = _value;
      } else {
        obj[_field] = _value;
      }
      obj.timestamp = new Date(_time);
      obj.who = who;
      hsh[_time] = obj;
      return hsh;
    }, {});

    const times = Object.keys(points)
    times.sort().reverse();
    const samples = times.map(t => points[t])
    return samples
  }, { refetchInterval: false, refetchOnWindowFocus: false });

  useEffect(() => {
    if (today && samples.length > 0) {
      let displaySamples = samples
      if (displaySamples.length === 0) {
        displaySamples = samples.slice(0, 1);
      }
      setDisplaySamples(displaySamples);
      const bounds = L.latLngBounds(displaySamples.map((s) => sampleLatLng(s)));
      setBounds(bounds);
    }
  }, [samples, today]);

  if (isLoading) {
    return (
      <div className="text-center justify-content-center p-5 align-items-center">
        <Spinner animation="border" role="status" size="xl" />
      </div>
    );
  }

  if (error) {
    return (
      <div className="text-center justify-content-center p-5 align-items-center">
        <Alert variant="danger">{error.message}</Alert>
      </div>
    );
  }

  if (displaySamples.length === 0) {
    return (
      <div className="text-center justify-content-center p-5 align-items-center">
        <div>No samples to show</div>
      </div>
    );
  }

  return (
    <>
      <Row>
        <Col>
          <MapContainer bounds={bounds} maxZoom={22} scrollWheelZoom>
            <MapGuts
              selectedIndex={-1}
              displaySamples={displaySamples}
              view={view}
              showHome={false}
            />
          </MapContainer>
        </Col>
      </Row>
    </>
  );
}
export default LastMonth;
